var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "bar-graph-background-container"
    }
  }, [_c('table', [_c('tr', _vm._l(_vm.columns, function (col, index) {
    return _c('td', {
      key: index,
      class: {
        currentBorder: _vm.hasCurrentBorderClass(index),
        rootColumnErrorBorder: _vm.hasRootBorderClass(index),
        errorBorder: _vm.hasErrorBorderClass(index)
      },
      style: {
        position: _vm.hasHintBorderClass(index) ? 'relative' : 'initial'
      }
    }, [_vm.hasHintBorderClass(index) ? _c('div', {
      staticClass: "hintBorder",
      attrs: {
        "id": "hintLine"
      }
    }) : _vm._e()]);
  }), 0)]), _c('div', _vm._l(_vm.columns, function (col, index) {
    return _c('div', {
      key: index,
      style: {
        width: _vm.columnWidth
      },
      attrs: {
        "id": "graph-column-label-container"
      }
    }, [_c('span', {
      class: {
        label: true,
        currentLabel: _vm.hasCurrentLabelClass(index),
        errorLabel: _vm.hasErrorLabelClass(index)
      }
    }, [_vm._v("\n        " + _vm._s(index * _vm.xAxisData.increment))]), index === _vm.columns.length - 1 ? _c('span', {
      class: {
        currentLabel: _vm.hasCurrentLabelClass(index, true),
        lastEvenLabel: _vm.hasLastEvenLabel(index),
        lastOddLabel: _vm.hasLastOddLabel(index),
        errorLabel: _vm.hasErrorLabelClass(index, true)
      }
    }, [_vm._v("\n        " + _vm._s(index * _vm.xAxisData.increment + _vm.xAxisData.increment))]) : _vm._e()]);
  }), 0), _c('div', {
    attrs: {
      "id": "graph-x-axis-label"
    }
  }, [_vm._v(_vm._s(_vm.xAxisData.label))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }